import {
  BrowserModule,
  HammerGestureConfig,
  HammerModule,
  HAMMER_GESTURE_CONFIG,
} from "@angular/platform-browser";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AuthorizationGuard } from "./authorization/authorization.guard";
import { OAuthModule } from "angular-oauth2-oidc";
import { HttpService } from "../app/shared/services/http.service";
import { HttpClientModule } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

// userDefined component
import { AppComponent } from "./app.component";
import { CarrierComponent } from "./carrier/carrier.component";
import { DeliveryComponent } from "./delivery/delivery.component";
import { GroupComponent } from "./group/group.component";
import { PlansComponent } from "./plans/plans.component";
import { HeaderComponent } from "./header/header.component";
import { AlertPopupComponent } from "./alert-popup/alert-popup.component";
import { NotfoundComponent } from "./notfound/notfound.component";
import { UnsupportedBrowserAlertComponent } from "./unsupported-browser-alert/unsupported-browser-alert.component";
import { ContributionComponent } from "./contribution/contribution.component";

// third Party component
import "hammerjs";
// import {
//   MatInputModule,
//   MatDatepickerModule,
//   MatNativeDateModule,
//   MatProgressBarModule,
//   MatDialogModule,
//   MatAutocompleteModule,
//   MatChipsModule,
//   MatProgressSpinnerModule,
//   MatSelectModule,
//   MatSliderModule,
//   MatIconModule,
//   MatSidenavModule,
//   MatRadioModule,
//   MatTabsModule,
//   GestureConfig,
// } from "@angular/material";
import { MatLegacyRadioModule as MatRadioModule } from "@angular/material/legacy-radio";
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from "@angular/material/legacy-progress-spinner";
import { MatLegacyDialogModule as MatDialogModule } from "@angular/material/legacy-dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatLegacySelectModule as MatSelectModule } from "@angular/material/legacy-select";
import { MatLegacyTabsModule as MatTabsModule } from "@angular/material/legacy-tabs";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatLegacyChipsModule as MatChipsModule } from "@angular/material/legacy-chips";
import { MatNativeDateModule } from "@angular/material/core";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatLegacyProgressBarModule as MatProgressBarModule } from "@angular/material/legacy-progress-bar";
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from "@angular/material/legacy-autocomplete";
import { MatLegacySliderModule as MatSliderModule } from "@angular/material/legacy-slider";

import { AuthorizationService } from "./authorization/authoriation.service";
import { NgIdleModule } from "@ng-idle/core";
//import { DeviceDetectorModule } from "ngx-device-detector";

import { AuthorizationModule } from "./authorization/authorization.module";
import { NgxSpinnerModule } from "ngx-spinner";

// custom pipes
import { DateFormatPipe } from "./shared/pipes/date-format.pipe";
import { NetworkTypePipe } from "./shared/pipes/network-type.pipe";
import { PackageSortPipe } from "./shared/pipes/package-sort.pipe";
import { DisclaimerComponent } from "./disclaimer/disclaimer.component";
import { PsContributionComponent } from './ps-contribution/ps-contribution.component';

@NgModule({
  declarations: [
    AppComponent,
    CarrierComponent,
    DeliveryComponent,
    GroupComponent,
    PlansComponent,
    HeaderComponent,
    AlertPopupComponent,
    DateFormatPipe,
    NotfoundComponent,
    NetworkTypePipe,
    PackageSortPipe,
    DisclaimerComponent,
    UnsupportedBrowserAlertComponent,
    ContributionComponent,
    PsContributionComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AuthorizationModule,
    OAuthModule.forRoot(),
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressBarModule,
    BrowserAnimationsModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatRadioModule,
    MatIconModule,
    MatSidenavModule,
    MatSliderModule,
    MatIconModule,
    MatSidenavModule,
    NgxSpinnerModule,
    NgIdleModule.forRoot(),
    //DeviceDetectorModule.forRoot(),
    MatTabsModule,
    HammerModule,
  ],
  providers: [
    AuthorizationGuard,
    HttpService,
    AuthorizationService,
    DateFormatPipe,
    //DeviceDetectorModule,
    { provide: HAMMER_GESTURE_CONFIG, useClass: HammerGestureConfig },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
